import { render, staticRenderFns } from "./HomepageHeroNew.vue?vue&type=template&id=8ce2e3ee&scoped=true&"
import script from "./HomepageHeroNew.vue?vue&type=script&lang=ts&"
export * from "./HomepageHeroNew.vue?vue&type=script&lang=ts&"
import style0 from "./HomepageHeroNew.vue?vue&type=style&index=0&id=8ce2e3ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ce2e3ee",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonSalesDialog: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/common/CommonSalesDialog.vue').default,CommonVideoPlayerDialog: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/common/CommonVideoPlayerDialog.vue').default})
